import { useTranslation } from "react-i18next";
import API from "./utils/API";
import Home from "./views/Home";
import Login from "./login/Login";
import { AgentUtils } from "./utils/AgentUtils";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Store } from "./utils/Store";

const theme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        marginNormal: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },
        /*root: {
          '&[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },*/
        /*inputRoot: {
          '&[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
            "& $input": {
              padding: "5px 4px",
            },
            '&[class*="MuiOutlinedInput-input"] ': {

            },
            "& $input:first-child": {
              paddingLeft: 2,
            },
          },
        },
        input: {
          padding: 0,
        },
        root: {
          padding: 0,
        },*/
      },
    },
    MuiChip: { styleOverrides: { root: { height: 20 } } },
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          padding: 2,
          color: "#555555",
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: "#fafafa",
          },
        },
      },
    },

    PrivateSwitchBase: {
      styleOverrides: {
        root: {
          padding: 0,
          marginLeft: 12,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        input: {
          padding: 5,
          marginLeft: 2,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          lineHeight: "0 rem",
        },
        root: {
          padding: 5,
        },
        paddingCheckbox: {
          width: 0,
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: 48,
          },
        },
      },
      MuiIconButton: {
        root: {
          padding: 2,
        },
      },
    },
  },
});

export default function App() {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [currentPage, setCurrentPage] = useState("");
  const [baseUrl, setBaseUrl] = useState("");
  const [context, setContext] = useState(null);
  const [userName, setUserName] = useState(null);
  const [productSearchCache, setProductSearchCache] = React.useState([]);
  const [productCache, setProductCache] = React.useState([]);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);
  useEffect(() => {
    if (localStorage.getItem("w_lang")) {
      i18n.changeLanguage(localStorage.getItem("w_lang"));
    }

    checkLogin();
  }, []);

  async function onLogin() {
    setBaseUrl(await AgentUtils.getBaseUrl());

    let context = {};
    console.log(await AgentUtils.getBaseUrl());
    let privs = await API.get("/auth/v1/users/myPrivileges");
    console.log(privs.data);
    context.privileges = privs.data;

    let { data } = await API.get("/api/v1/setting/store");
    if (!data.shopType) {
      data.shopType = "SHOP";
    }
    context.store = data;

    let storeAdmin = await API.get("/api/v1/setting/store_admin");
    context.storeAdmin = storeAdmin.data;

    let saleSetting = await API.get("/api/v1/setting/sale");
    context.saleSetting = saleSetting.data;

    let deli = await API.get("/api/v1/setting/deli");
    context.deliSettings = deli.data;

    let categories = await API.get("/api/v1/allcategorys");
    let deliCodes = [];
    for (let cat of categories.data) {
      if (cat.level == 0 && cat.deliItem) {
        deliCodes.push(cat.groupCode);
      }
    }
    context.deliCodes = deliCodes;
    context["appMode"] = "desktop-pos";
    context["appType"] = data.appType;

    setContext(context);

    setCurrentPage("home");
  }

  async function checkLogin() {
    let token = localStorage.getItem("w_refreshToken");
    try {
      if (token) {
        console.log("App login");
        const response = await fetch(baseUrl + "/auth/v1/users/signin", {
          method: "post",
          body: JSON.stringify({
            token: token,
          }),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(response.statusText);
        }
        const data = await response.json();

        console.log("LOGIN", data);
        localStorage.setItem("w_accessToken", data.accessToken);
        localStorage.setItem("w_refreshToken", data.refreshToken);
        setUserName(data.name);
        API.defaults.headers.common = {
          Authorization: `Bearer ${data.refreshToken}`,
          baseURL: await AgentUtils.getBaseUrl(),
        };

        let jwt = Store.parseJwt(data.accessToken);

        await API.post("/api/v1/ejectuser", {
          accessTokenHash: Store.hashCode(data.accessToken),
          userName: jwt.sub,
        });

        await onLogin();
        setCurrentPage("home");
      } else {
        setCurrentPage("login");
      }
    } catch (err) {
      console.log(err);
      setCurrentPage("login");
    }
  }
  return (
    <div id="app">
      {currentPage === "login" && (
        <Login
          baseUrl={baseUrl}
          onLogin={onLogin}
          setUserName={setUserName}
        ></Login>
      )}
      {currentPage === "home" && (
        <ThemeProvider theme={theme}>
          <Home
            baseUrl={baseUrl}
            context={context}
            setContext={setContext}
            setCurrentPage={setCurrentPage}
            userName={userName}
            productCache={productCache}
            setProductCache={setProductCache}
            productSearchCache={productSearchCache}
            setProductSearchCache={setProductSearchCache}
          ></Home>
        </ThemeProvider>
      )}
    </div>
  );
}
